import { IframeQueryParameters } from '@wix/wix-chatbot-common/browser';
import { createPath } from 'history';
import { matchPath, matchRoutes } from 'react-router-dom';

import { getLast } from '../../util/guards';
import { AppRoutePatterns, appRoutes, routePathObjects } from './appRoutes';

export function trimBaseName(routerBaseName: string, url: string): string {
  return url.replace(routerBaseName, '');
}

export function getRouterBaseName(pathname: string): string {
  const pathItems = pathname.split('/').filter((path) => !!path);
  const widgetPathIndex = pathItems.findIndex((path) => path === 'widget');

  if (widgetPathIndex === -1) {
    return `/${pathItems[0] || ''}`;
  } else {
    return `/${pathItems.slice(0, widgetPathIndex + 1).join('/')}`;
  }
}

export const isRouteValid = (route: string): boolean => !!matchRoutes(routePathObjects, route);

export function getInitialEntries(history: string[]): string[] {
  const sanitizedHistory = history.filter(
    (url, index) => !!matchRoutes(routePathObjects, url) && url !== history[index - 1],
  );

  // First item in 'initialEntries' should always be Homepage(by design).
  const firstEntries = sanitizedHistory[0];
  if (!firstEntries || !matchPath(AppRoutePatterns.Home, firstEntries)) {
    sanitizedHistory.unshift(appRoutes.home());
  }

  const startRouteFromUrl = getStartRouteFromUrl();
  const lastHistoryRoute = getLast(sanitizedHistory);

  if (startRouteFromUrl && startRouteFromUrl !== lastHistoryRoute) {
    sanitizedHistory.push(startRouteFromUrl);
  }

  return sanitizedHistory;
}

export function getStartRouteFromUrl(): string | undefined {
  const url = new URL(window.location.href);
  const applyUrlToRouter = url.searchParams.get(IframeQueryParameters.applyUrlToRouter);

  if (applyUrlToRouter !== null) {
    const { pathname, search, hash } = url;

    // we need to remove basename before using it in Router
    return trimBaseName(
      getRouterBaseName(pathname),
      // use only pathname and hash(for article anchors) to omit unnecessary query params for router(nodeId, suggestionId etc.)
      createPath({
        pathname,
        search,
        hash,
      }),
    );
  }
}
